import { render, staticRenderFns } from "./LogoBlue.vue?vue&type=template&id=2b38d0dc&"
import script from "./LogoBlue.vue?vue&type=script&lang=js&"
export * from "./LogoBlue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports